import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ChatContextType {
  isChatOpen: boolean;
  activeSessionId: string | null;
  toggleChat: () => void;
  closeChat: () => void;
  setActiveSessionId: (id: string | null) => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (context === undefined) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
};

interface ChatProviderProps {
  children: ReactNode;
}

export const ChatProvider: React.FC<ChatProviderProps> = ({ children }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [activeSessionId, setActiveSessionId] = useState<string | null>(null);

  const toggleChat = () => setIsChatOpen((prev) => !prev);
  const closeChat = () => setIsChatOpen(false);

  return (
    <ChatContext.Provider
      value={{
        isChatOpen,
        activeSessionId,
        toggleChat,
        closeChat,
        setActiveSessionId,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
